import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useFetch } from "../api";
import { Alerts, Badge, EmptyRow, Facts, Loading, Page, Pager, UserLink } from "../components/ui";
import { money, PAGE_SIZE, qs, setQuery, text, when } from "../format";

export default function Transfers() {
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const page = Math.max(1, Number(params.get("page")) || 1);
  const list = useFetch("/transfers" + qs({ page, limit: PAGE_SIZE }));
  const rows = Array.isArray(list.data?.data) ? list.data.data : [];

  return (
    <Page title="Transfers" text="Transfers move the single wallet from one member to another and finish immediately. They are not reversed here.">
      <Alerts error={list.error} />
      {list.loading ? <Loading /> : (
        <div className="table-wrap">
          <table className="wide">
            <thead>
              <tr>
                <th>From</th><th>To</th><th className="num">Amount</th><th>Note</th><th>Status</th><th>Time</th>
              </tr>
            </thead>
            <tbody>
              {rows.length ? rows.map((row) => (
                <tr key={row.id} className="click" onClick={() => navigate("/admin/transfers/" + row.id)}>
                  <td onClick={(event) => event.stopPropagation()}><UserLink user={row.sender} /></td>
                  <td onClick={(event) => event.stopPropagation()}><UserLink user={row.recipient} /></td>
                  <td className="num">{money(row.amount)}</td>
                  <td>{text(row.note)}</td>
                  <td><Badge value={row.status} /></td>
                  <td>{when(row.createdAt)}</td>
                </tr>
              )) : <EmptyRow cols={6} text="No transfers" />}
            </tbody>
          </table>
        </div>
      )}
      {list.data ? (
        <Pager page={page} limit={PAGE_SIZE} total={list.data.total} onPage={(next) => setQuery(params, setParams, { page: next <= 1 ? "" : next })} />
      ) : null}
    </Page>
  );
}

export function TransferDetail() {
  const { id } = useParams();
  const { data, loading, error } = useFetch("/transfers/" + id);
  const row = data?.data;

  return (
    <Page title="Transfer">
      <Link className="back" to="/admin/transfers">Back to transfers</Link>
      <Alerts error={error} />
      {loading ? <Loading /> : null}
      {row ? (
        <div className="panel">
          <Facts items={[
            { label: "Amount", value: money(row.amount) },
            { label: "Status", value: <Badge value={row.status} /> },
            { label: "From", value: <UserLink user={row.sender} /> },
            { label: "To", value: <UserLink user={row.recipient} /> },
            { label: "Note", value: text(row.note), wide: true },
            { label: "Time", value: when(row.createdAt) },
          ]} />
        </div>
      ) : null}
    </Page>
  );
}
